// Ported verbatim from https://voiceorbs.vercel.app/orbs/particles-orb (`src/registry/lib/use-reduced-motion.ts`)
// -- see orb-state.ts's header comment for provenance.
"use client";
import { useSyncExternalStore } from "react";
export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
export const prefersReducedMotion = () => typeof window !== "undefined" && window.matchMedia(REDUCED_MOTION_QUERY).matches;
export const subscribeReducedMotion = (onChange) => {
    const mq = window.matchMedia(REDUCED_MOTION_QUERY);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
};
export const useReducedMotion = () => useSyncExternalStore(subscribeReducedMotion, prefersReducedMotion, () => false);
